import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedinfoService } from '../nservices/sharedinfo.service';
import { PublicationModel } from '../nmodels/publication.model';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.css']
})
export class AsideComponent implements OnInit {
  publications?:PublicationModel[];
  
  isempty:boolean = false;
  @ViewChild('exampleModalLong') myModal;


  constructor(private _router:Router,
              private _sharedInfoS:SharedinfoService) {
                // console.log("constructor de aside");
                
    this._sharedInfoS.subjectPublications.subscribe(data =>{
      console.log("subject publicacion recived");
      this.publications = data;
      console.log(this.publications);
      
      if(this.publications.length!=0)
        this.isempty = false;
      else
        this.isempty = true;
    });
  }

  ngOnInit() {

  }

  details(idx){
    this._sharedInfoS.setasParamPublication(this.publications[idx]);
    this._router.navigate(['detailsPublication']);
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/aside/aside.component.ts